/** E-mails da equipe do cliente usados no convite da Google Agenda. */

export interface ClientEmail {
  id?: string;
  name: string;
  email: string;
  role?: string | null;
  isPrimary?: boolean;
  inviteCalendar: boolean;
}

export interface CatalogClient {
  id: string;
  name: string;
  color: string;
  timezone: string;
  notes: string | null;
  handle: string;
  hasPin: boolean;
  hasLogo?: boolean;
  logoUrl?: string | null;
  email: string | null;
  emails?: ClientEmail[];
}

const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function isValidEmail(value: string): boolean {
  return EMAIL_PATTERN.test(value.trim());
}

export function clientInviteEmails(client: {
  email?: string | null;
  emails?: Array<{ email: string; inviteCalendar?: boolean }>;
}): string[] {
  const listed = (client.emails ?? [])
    .filter((item) => item.inviteCalendar !== false)
    .map((item) => item.email.trim().toLowerCase())
    .filter((email) => email.includes("@"));
  const unique = [...new Set(listed)];
  if (unique.length > 0) return unique;
  const fallback = client.email?.trim().toLowerCase() ?? "";
  return fallback.includes("@") ? [fallback] : [];
}

export function formatInviteEmails(emails: string[]): string {
  if (emails.length === 0) return "";
  if (emails.length === 1) return emails[0] ?? "";
  if (emails.length === 2) return `${emails[0]} e ${emails[1]}`;
  return `${emails[0]} e mais ${emails.length - 1}`;
}

export function inviteEmailSummary(client: {
  email?: string | null;
  emails?: Array<{ email: string; inviteCalendar?: boolean }>;
}): string {
  const emails = clientInviteEmails(client);
  if (emails.length === 0) return "Sem e-mail para convite da Agenda";
  if (emails.length === 1) return emails[0] ?? "";
  return `${emails.length} e-mails para convite da Agenda`;
}
